import React from "react"

const RegistrationHeaderStep1 = props => {
    return (
        <div>
            <h2 className="mainform">Tell us a few details about yourself</h2>
        </div>)
};

const RegistrationHeaderStep2 = props => {
    return (
        <div>
            <h2 className="nextform">Tell us how you use freight</h2>

        </div> )
};

const RegistrationHeaderStep3 = RegistrationHeaderStep2;

const RegistrationHeaderStep4 = props => {

    return <div>
        <h2 className="lastpage">You're all done, please wait 24 hours for our team to set up your account.</h2>
        <p className="lastpage">If you have an urgent booking, please call us on 13 12 13 or email us at&nbsp;
            <a href="mailto:freightcustomerservice@qantas.com.au">freightcustomerservice@qantas.com.au</a>
        </p>

    </div>

};

const RegistrationHeader = props => {

    const getStepsDone = () => {
        switch (props.active) {
            case 1:
                return 'step-2';
            case 2:
                return 'step-2 step-3';
            case 3:
                return 'step-2 step-3 step-4';
            default:
                return '';
        }
    };


    let stepsIconClass = "regn-steps " + getStepsDone();
    return (
        <div className="steps-header">
            <div className="component-holder registration-details">
                <div className="regn-header-text">
                    {props.flow.view}
                </div>
            </div>
            <div className="component-holder">
                <div className={stepsIconClass}>
                    <RegistrationIcon text="1" position="first" active={props.active === 0}/>
                    <div className="divider first"/>
                    <RegistrationIcon text="2" position="mid" active={props.active === 1}/>
                    <div className="divider last"/>
                    <RegistrationIcon text="3" position="last" active={props.active === 2}/>
                </div>
            </div>
        </div>
    )
};

const RegistrationIcon = props => {

    let wrapperClass = 'regn-step ' + props.position + (props.active ? ' active' : '');
    return (
        <div className={wrapperClass}>
            <span className="txt">{props.text}</span>
            <span className="check">
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
    <path fill="#4A4A4A" fillRule="evenodd"
          d="M2.403 10.889l1.133 1.132 8.485-8.485-1.271-1.272-7.071 7.071-2.265-2.264L0 8.485l2.403 2.404z"/>
    </svg>
    </span>
        </div>
    )
};


export {
    RegistrationHeader,
    RegistrationHeaderStep1,
    RegistrationHeaderStep2,
    RegistrationHeaderStep3,
    RegistrationHeaderStep4
}